<button class="icon-left" mat-icon-button [matMenuTriggerFor]="ioFilterMenu" aria-label="Filter">
    <mat-icon [ngClass]="{'material-icons-outlined' : !hasFilterSelected()}">filter_alt</mat-icon>
</button>
<mat-menu #ioFilterMenu="matMenu">
    <div class="ioFilterContent" (click)="$event.stopPropagation()">
        <div>
            <button class="clear-button" mat-icon-button (click)="clearFilters()">
                <div class="icon-container">
                    <mat-icon>block</mat-icon>
                </div>
                <span class="text-container">Clear filter</span>
            </button>
        </div>
        <div class="small-margin-left">
            <div><mat-checkbox [(ngModel)]="filter.isOrder" color="primary" (change)="invokeSelectionChanged()"><mat-icon svgIcon="arrow-right" class="medium-margin-left middle icon-16"></mat-icon>&nbsp; Order</mat-checkbox></div>
        </div>
        <div class="small-margin-left">
            <div><mat-checkbox [(ngModel)]="filter.isResult" color="primary" (change)="invokeSelectionChanged()"><mat-icon svgIcon="arrow-left" class="medium-margin-left middle icon-16"></mat-icon>&nbsp; Result</mat-checkbox></div>
        </div>
        <div class="small-margin-left">
            <div><mat-checkbox [(ngModel)]="filter.isInvoice" color="primary" (change)="invokeSelectionChanged()"><mat-icon svgIcon="arrow-left-hollow" class="medium-margin-left middle icon-16"></mat-icon>&nbsp; Invoice</mat-checkbox></div>
        </div>
        <div class="small-margin-left">
            <div><mat-checkbox [(ngModel)]="filter.isAction" color="primary" (change)="invokeSelectionChanged()"><mat-icon svgIcon="arrow-right-hollow" class="medium-margin-left middle icon-16"></mat-icon>&nbsp; Action</mat-checkbox></div>
        </div>
    </div>
</mat-menu>